// src/pages/admin/Transactions.js
import React from "react";
import AdminTransactions from "../../components/Admin/AdminTransactions";

export default function AdminTransactionsPage() {
  return <AdminTransactions />;
}
